import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  ViewEncapsulation,
  OnDestroy
} from "@angular/core";
import { WarehouseSlaService } from "./service/warehouse-sla.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-warehouse-sla",
  templateUrl: "./widget-warehouse-sla.component.html",
  styleUrls: ["./widget-warehouse-sla.component.scss"],
  providers: [WarehouseSlaService]
})
export class WidgetWarehouseSlaComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 19;

  highcharts: typeof Highcharts = Highcharts;
  chartOption1 = null;
  chartOption2 = HSET.chart2;
  errorMessage = "";
  mockChart = null;
  mockChart2 = null;
  loadingChart = true;

  constructor(
    private translateService: TranslateService,
    private dataService: WarehouseSlaService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getWarehouseSLA();
    }
  }

  ngOnInit() {
    this.translateService.get("WAREHOUSE.WAREHOUSE_SLA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.setWidgetData();
      });
    this.getWarehouseSLA();
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOption2) {
      this.chartOption2.series[2].data = [];
      for (let i = 0; i < this.chartOption2.series[0].data.length; i++) {
        this.chartOption2.series[2].data.push(t);
      }
    }
  }

  getWarehouseSLA() {
    const params = {};
    this.errorMessage = "";
    this.mockChart = null;
    this.mockChart2 = null;

    this.chartOption1 = null;
    this.chartOption2.series[0].data = [];
    this.loadingChart = true;

    this.dataService.getWarehouseSLA(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData.chart2["dataKeys"].length) {
            this.loadingChart = true;

            const charts = this.dataService.createChart(chartData, this.OPTIONS);
            this.chartOption1 = charts.chart1;
            this.chartOption2 = charts.chart2;
            this.setWidgetData();
            this.loadingChart = false;
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chart1;
            this.mockChart2 = HSET.chart2;
            this.loadingChart = true;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chart1;
          this.mockChart2 = HSET.chart2;
          this.loadingChart = true;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
